export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 15, 20];
export const DEFAULT_PAGE_LENGTH = 1;
export const MINIMUM_PAGE_COUNT = 1;
export const MINIMUM_PAGE_ITEM = 1;
export const MAX_PAGE_SIZE = 40;
